import React from 'react'
import Hero from './Hero'
import HeroAd from './HeroAd'
import FouderList from '../../components/FouderList'
import CategoryList from './CategoryList'
import ServiceMap from '../../components/ServiceMap'

function AboutUs() {
    return (
        <div>
            <Hero />
            <HeroAd />
            <FouderList />
            <CategoryList />
            <ServiceMap />
        </div>
    )
}

export default AboutUs